import { render, staticRenderFns } from "./social-share.vue?vue&type=template&id=2cba0536&"
import script from "./social-share.vue?vue&type=script&lang=js&"
export * from "./social-share.vue?vue&type=script&lang=js&"
import style0 from "./social-share.vue?vue&type=style&index=0&id=2cba0536&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports